"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceImage = void 0;
/* eslint-disable global-require */
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Image = styled_components_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var DeviceImage = function (_a) {
    var trezorModel = _a.trezorModel, _b = _a.height, height = _b === void 0 ? '100%' : _b, hires = _a.hires, className = _a.className;
    switch (trezorModel) {
        case 1:
            return (react_1.default.createElement(Image, { className: className, height: height, alt: "trezor T1", src: hires
                    ? require("../../images/trezor/T1_hires.png")
                    : require("../../images/trezor/T1.png"), srcSet: hires
                    ? require('../../images/trezor/T1_hires.png') + " 1x, " + require('../../images/trezor/T1_hires@2x.png') + " 2x"
                    : undefined }));
        case 2:
            return (react_1.default.createElement(Image, { className: className, height: height, alt: "trezor T2", src: hires
                    ? require("../../images/trezor/T2_hires.png")
                    : require("../../images/trezor/T2.png"), srcSet: hires
                    ? require('../../images/trezor/T2_hires.png') + " 1x, " + require('../../images/trezor/T2_hires@2x.png') + " 2x"
                    : undefined }));
        // no default
    }
};
exports.DeviceImage = DeviceImage;
var templateObject_1;
